import { render, staticRenderFns } from "./ChartLine.vue?vue&type=template&id=506fb298&scoped=true"
import script from "./ChartLine.vue?vue&type=script&lang=js"
export * from "./ChartLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506fb298",
  null
  
)

export default component.exports